import React from 'react'

import { NavigationButtonBase } from './styles'
import IconArrowLeft from 'client/icons/ChevronLeft'
import IconArrowRight from 'client/icons/ChevronRight'

interface INavigationButton {
  className?: string
  'data-testid'?: string
  direction: 'right' | 'left'
  onClick?: () => void
}

const NavigationButton = ({
  className,
  onClick,
  direction,
  'data-testid': dataTestId,
}: INavigationButton) => {
  return (
    <NavigationButtonBase className={className} data-testid={dataTestId} onClick={onClick}>
      {direction === 'right' ? <IconArrowRight /> : <IconArrowLeft />}
    </NavigationButtonBase>
  )
}

export default NavigationButton
